!function () {
	if (window.golfbox === undefined) {
		window.golfbox = window.gb = {};
	}

	let _ = {};
    window.gb.number = _;

    _.toCurrency = function (value, options) {
        let o = {
            decimalDigits:      (options ? options.decimalDigits : null) || 2,
            decimalSeparator:   (options ? options.decimalSeparator : null) || '.',
            groupSeparator:     (options ? options.groupSeparator : null) || ',',
            groupSizes:         (options ? options.groupSizes : null) || 3
        };
        let negative = value < 0;
        if (negative) {
            value = value * -1;
        }

        let parts = value.toFixed(o.decimalDigits).toString().split('.');
        let result = '';

        if (o.groupSizes && parts[0].length > o.groupSizes) {
            let nextIndex = parts[0].length;

            while (nextIndex > 0) {
                nextIndex -= o.groupSizes;
                if (nextIndex >= 0) {
                    result = parts[0].substr(nextIndex, o.groupSizes)
                        + (result ? o.groupSeparator + result : '');
                } else {
                    result = parts[0].substr(0, o.groupSizes + nextIndex)
                        + (result ? o.groupSeparator + result : '');
                }
            }
        } else {
            result = parts[0];
        }

        result = (negative ? '-' : '') + result + o.decimalSeparator + parts[1];

        console.log('currency: ' + result);
        return result;
    };
}()